function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.333,
    cy: 14.594,
    r: 3.38,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.667,
    cy: 14.594,
    r: 3.38,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.792,17.974h3.031v.333h-3.031v-.333ZM9.792,18.651h10.417v.167h-10.417v-.167ZM9.792,19.161h10.417v.26h-10.417v-.26ZM9.792,19.682h10.417v.333h-10.417v-.333ZM9.792,20.182h10.417v.521h-10.417v-.521ZM20.208,17.974h-3.031v.333h3.031v-.333Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.646,
    cy: 13.448,
    r: 3.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.073,
    cy: 13.771,
    r: 3.38,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 11.396,
    r: 1.354,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.208,
    cy: 13.958,
    r: 3.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.052,
    cy: 18.198,
    r: 3.974,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.146,
    cy: 18.573,
    r: 3.974,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.948,
    cy: 15.219,
    r: 1.354,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.469,
    cy: 18.875,
    r: 3.974,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.958,15.521l.625.521h.521v1.042h-.625l-.521-1.563Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.948,
    cy: 18.198,
    r: 3.974,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.854,
    cy: 18.573,
    r: 3.974,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.052,
    cy: 15.219,
    r: 1.354,
    style: {
      fill: "#0f7562"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.531,
    cy: 18.875,
    r: 3.974,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.042,15.521l-.625.521h-.521v1.042h.625l.521-1.563Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.451 10.965 13.003 10.974 12.562 10.641 12.742 10.119 12.289 10.436 11.848 10.103 12.009 10.631 11.557 10.948 12.11 10.957 12.271 11.486 12.451 10.965",
    style: {
      fill: "#ffde23"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.907 12.39 10.802 11.849 10.569 12.35 10.02 12.282 10.424 12.659 10.191 13.159 10.674 12.891 11.078 13.268 10.973 12.726 11.456 12.458 10.907 12.39",
    style: {
      fill: "#ffde23"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.991 10.631 18.152 10.103 17.711 10.436 17.258 10.119 17.438 10.641 16.997 10.974 17.549 10.965 17.729 11.486 17.89 10.957 18.443 10.948 17.991 10.631",
    style: {
      fill: "#ffde23"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.576 12.659 19.98 12.282 19.431 12.35 19.198 11.849 19.093 12.39 18.544 12.458 19.027 12.726 18.922 13.268 19.326 12.891 19.809 13.159 19.576 12.659",
    style: {
      fill: "#ffde23"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.247 9.53 15 8.771 14.753 9.53 13.955 9.53 14.601 10 14.354 10.759 15 10.29 15.646 10.759 15.399 10 16.045 9.53 15.247 9.53",
    style: {
      fill: "#ffde23"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/MO.345965ba543271e096bc250783a68e28.svg";
export { ForwardRef as ReactComponent };